import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartConfiguration } from 'chart.js';
import { DashboardResponse, DataRecord } from 'src/app/pages/dashboard/models/Dashboard.types';
import { CashPositioning, StackedBarLineDataSet } from '../../models/cashPositioning.types';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexYAxis,
  ApexTooltip,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexMarkers
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  title: ApexTitleSubtitle;
  labels: string[];
  stroke: any; // ApexStroke;
  dataLabels: any; // ApexDataLabels;
  fill: ApexFill;
  tooltip: ApexTooltip;
  markers: ApexMarkers
};

@Component({
  selector: 'app-stackedBarline-chart',
  templateUrl: './stackedBar-line-chart.component.html',
  styleUrls: ['./stackedBar-line-chart.component.scss'],
  standalone: false
})
export class StackedBarLineComponent implements OnInit {

  //Get APEX chart
  @ViewChild("chart") chart: ChartComponent;
  //APEX Chart Options
  public chartOptions: Partial<ChartOptions>;

  @Input() stackedBarLineData: DashboardResponse[];
  barLineChartOptions: ChartConfiguration<'line'>['options'] = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        ticks: {
          callback: function (value: any, index: any, ticks: any) {
            value = value.toLocaleString('en-US', {
              style: 'decimal',
              useGrouping: true,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return value;
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  cashPositioning: CashPositioning<StackedBarLineDataSet[]> = {
    labels: [],
    datasets: [],

  }

  constructor(public _translate: TranslateService) {

    //Render APEX chart
    this.chartOptions = {
      series: [
        {
          name: "Website Blog",
          type: "column",
          data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
        },
        {
          name: "Social Media",
          type: "line",
          data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
        }
      ],
      //line on top of bars
      markers: {
        size: [5],
        colors: ['#4169E1'],
        strokeColors: '#4169E1',
        strokeWidth: 2,
        strokeOpacity: 0.9,
        strokeDashArray: 0,
        fillOpacity: 1,
        discrete: [],
        shape: "circle",
        offsetX: 0,
        offsetY: 0,
        onClick: undefined,
        onDblClick: undefined,
        showNullDataPoints: true,
        hover: {
          size: undefined,
          sizeOffset: 3
        }
      },
      chart: {
        height: 350,
        type: "line",
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        // text: "Traffic Sources"
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      // labels: [
      //   "01 Jan 2001",
      //   "02 Jan 2001",
      //   "03 Jan 2001",
      //   "04 Jan 2001",
      //   "05 Jan 2001",
      //   "06 Jan 2001",
      //   "07 Jan 2001",
      //   "08 Jan 2001",
      //   "09 Jan 2001",
      //   "10 Jan 2001",
      //   "11 Jan 2001",
      //   "12 Jan 2001"
      // ],
      xaxis: {
        type: "category"
      },
      yaxis: [
        {
          title: {
            // text: "Website Blog"
          }
        },
        {
          opposite: true,
          title: {
            // text: "Social Media"
          }
        }
      ],
      fill: {
        opacity: 1,
        // colors: ['#0A2129', '#5C4742'],
      },
    };
  }

  ngOnInit(): void {
    this.adjustCashPositioningData();
  }

  adjustCashPositioningData() {
    this.stackedBarLineData.forEach(chart => {
      let dataSet: any = {
        label: '',
        data: [],
        borderColor: "#0A2129",
        pointBorderColor: "#0A2129",
        pointBackgroundColor: "#0A2129",
        pointHoverBackgroundColor: "#0A2129",
        pointHoverBorderColor: "#0A2129",
        barThickness: 6,
        type: "bar",
        borderRadius: 0,
        backgroundColor: '#0A2129',
        hoverBackgroundColor: '#0A2129',
        stack: "combined"
      }
      chart.dataRecords.forEach(account => {
        account.dataRecords.forEach((subAccount, index) => {
          this.cashPositioning.labels.push((this._translate.currentLang == 'en' ? account.titleEn : account.titleAr));
          subAccount.dataRecords.length == 0 ? dataSet.data.push(subAccount.value) : dataSet.data.push(subAccount.dataRecords);
          dataSet.backgroundColor = 'rgba(10, 33, 41, ' + (1 / (index + 1)) + ')';
          dataSet.hoverBackgroundColor = 'rgba(10, 33, 41, ' + (1 / (index + 1.2)) + ')';
          this.cashPositioning.datasets.push(dataSet);
        })
      });

      //console.log(this.cashPositioning.datasets);

    });
    this.cashPositioning.datasets.push({
      label: "",
      data: [],
      borderColor: "#58BEF3",
      backgroundColor: "#58BEF3",
      stack: "combined",
      pointBorderColor: null,
      pointBackgroundColor: null,
      pointHoverBackgroundColor: null,
      pointHoverBorderColor: null,
      barThickness: null
    });
    this.stackedBarLineData.forEach(lineCart => {
      for (let i = 0; i < this.cashPositioning.labels.length; i++) {
        // this.cashPositioning.labels.push('label');
        this.cashPositioning.datasets[this.cashPositioning.datasets.length - 1].data.push(0)
      }
    })


    //console.log(this.cashPositioning);

  }


}
